import clx from 'classnames';
import { SIZE, VARIANT_COLOR_ENUM } from 'types/utils';

export const CARD_BADGE_VARIANT = {
  [VARIANT_COLOR_ENUM.PRIMARY]: 'text-primary-500',
  [VARIANT_COLOR_ENUM.ERROR]: 'text-system-error-400',
  [VARIANT_COLOR_ENUM.NEUTRAL]: 'text-neutral-500',
  [VARIANT_COLOR_ENUM.NEUTRAL_DARK]: 'text-neutral-700',
  [VARIANT_COLOR_ENUM.NUBLU]: 'text-nublu-500',
  [VARIANT_COLOR_ENUM.DISABLED]: 'text-neutral-500',
  [VARIANT_COLOR_ENUM.INFO]: 'text-neutral-500',
  [VARIANT_COLOR_ENUM.SECONDARY]: 'text-neutral-500',
  [VARIANT_COLOR_ENUM.SUCCESS]: 'text-neutral-500',
  WARNING: 'text-security-orange-400',
  SECURITY_BLUE: 'text-security-blue-400',
  SECURITY_GREEN: 'text-security-green-400',
};

export type CardBadgeProps = {
  children?: string | number | JSX.Element;
  variant?: keyof typeof CARD_BADGE_VARIANT;
  className?: string;
  icon?: string;
  size?: SIZE;
  inverted?: boolean;
};
const SIZE_TO_CSS: Record<string, string> = {};

SIZE_TO_CSS[SIZE.LG] = SIZE_TO_CSS[SIZE.MD];
SIZE_TO_CSS[SIZE.MD] = 'sm-medium';
SIZE_TO_CSS[SIZE.SM] = 'xs-medium';
const SIZE_TO_CONTAINER_CSS = {
  [SIZE.LG]: 'min-w-3',
  [SIZE.MD]: 'min-w-6 min-h-6',
  [SIZE.SM]: 'min-w-[18px] min-h-[18px]',
};

const CardBadge = ({
  children,
  variant = VARIANT_COLOR_ENUM.NUBLU,
  icon,
  className,
  size = SIZE.MD,
  inverted,
}: CardBadgeProps) => (
  <div
    className={clx(
      'rounded-xs leading-none',
      variant && CARD_BADGE_VARIANT[variant],
      inverted ? 'bg-transparent' : 'bg-current',
      className,
    )}
  >
    <div
      className={clx(
        'flex justify-center items-center gap-1 p-1 font-bold',
        inverted ? CARD_BADGE_VARIANT[variant] : 'text-neutral-50',
        SIZE_TO_CONTAINER_CSS[size],
      )}
    >
      <i className={clx(icon, SIZE_TO_CSS[size])} />
      {children && <div className="text-sm">{children}</div>}
    </div>
  </div>
);

export default CardBadge;
